// imports
import DrupalView from 'minsky-kit/js/components/DrupalView';

// private statics

// class definition
export default class WADDrupalView extends DrupalView {
    // constructor
    constructor (args = {}, objectName = 'WADDrupalView') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // add extra observer for when pagers are present
        // assuming ajax will be enabled and changes to view-rows need to be detected
        if (this.$el.querySelector('.pager')) {
            const $rows = this.$el.querySelector('.views-infinite-scroll-content-wrapper');

            if ($rows) {
                this._rowsObserver = new MutationObserver(this.blm.add('onRowsMutation', onRowsMutation));
                this._rowsObserver.observe($rows, {
                    childList: true,
                });

                initRows.call(this, true);
            }
        }
    }

    // methods

    destroy () {
        if (this._rowsObserver) {
            this._rowsObserver.disconnect();
            this._rowsObserver.takeRecords();
            this._rowsObserver = null;
        }

        super.destroy();
    }

    // getters & setters
}

// Utils
function initRows (silent = false) {
    // no need to destroy the old view as the element is removed and lost for ever.
    const $oldRows = this._$rows;
    this._$rows = this.$el.querySelector('.views-infinite-scroll-content-wrapper');

    if (!silent) {
        this.dispatch('view-rows_refresh', {
            new: this._$rows,
            old: $oldRows,
        });
    }
}

// Event handlers
function onRowsMutation () {
    initRows.call(this);
}
